import React, {Component} from "react";
import {Row, Col, Modal, Card, CardBody} from "reactstrap";
import {withTranslation} from "react-i18next";
import FileViewer from "./FileViewer";

class ViewerModal extends Component {
  constructor(props) {
    super(props)
  }

  onClose = () => {
    this.props.togModal()
  }

  render() {
    return (<React.Fragment>
      <Modal isOpen={true} toggle={this.onClose} size="xl">
        <div className="modal-header">
          <h5 className="modal-title mt-0">
            Viewer
          </h5>
          <button type="button" onClick={this.onClose} className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <Card>
          <CardBody>
            <Row className="mb-2">
              <Col className="col-12" style={{"height": "85vh", "overflow": "scroll"}}>
                <FileViewer sign={this.props.viewerData.sign} name={this.props.viewerData.name}/>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Modal>
    </React.Fragment>)
  }
}

export default withTranslation()(ViewerModal);
